// Brand palette for the admin theme.
export const brand = {
  primary: '#1E40AF', // indigo-800
  primaryLight: '#3B82F6',
  secondary: '#7C3AED', // violet-600
  success: '#16A34A',
  warning: '#D97706',
  error: '#DC2626',
  info: '#0891B2',
};

export const getPalette = (mode) => ({
  mode,
  primary: { main: brand.primary, light: brand.primaryLight },
  secondary: { main: brand.secondary },
  success: { main: brand.success },
  warning: { main: brand.warning },
  error: { main: brand.error },
  info: { main: brand.info },
  background:
    mode === 'light'
      ? { default: '#F4F6F8', paper: '#FFFFFF' }
      : { default: '#0B1120', paper: '#111827' },
});
